import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { clearEntityMentionSearch, searchEntityMentions } from "../store/actions";
import {
  getEntityMentionSearchedQuery,
  getEntityMentionSearchLoading,
  getEntityMentionSearchResults,
} from "../store/selectors";

const useEntityMentionSearch = (query: string) => {
  const dispatch = useDispatch();
  const searchLoading = useSelector(getEntityMentionSearchLoading);
  const searchedQuery = useSelector(getEntityMentionSearchedQuery);
  const results = useSelector(getEntityMentionSearchResults);

  useEffect(() => {
    if (query.length >= 1) {
      dispatch(searchEntityMentions.request({ query }));
    } else {
      dispatch(clearEntityMentionSearch());
    }
  }, [dispatch, query]);

  const loading = query.length >= 1 && (searchLoading || searchedQuery !== query);

  const reset = useCallback(() => {
    dispatch(clearEntityMentionSearch());
  }, [dispatch]);

  return { loading, reset, results };
};

export default useEntityMentionSearch;
